import styled from "styled-components";

import { COLORS } from "../../../constants/Styles";

const Container = styled.div<{ checked?: boolean }>`
  cursor: pointer;
  display: flex;
  align-items: center;

  > label {
    margin-left: 0.25rem;
    cursor: pointer;
  }

  > input[type="radio"] {
    border: 1px solid ${COLORS.badgeGray};
    appearance: none;
    width: 0.75rem;
    height: 0.75rem;
    border-radius: 50%;
    position: relative;
    margin-right: 0.25rem;
    cursor: pointer;
  }

  ${({ checked }) =>
    checked &&
    `
    > input[type="radio"] {
        background-color: ${COLORS.inputGray};
    }
    
    > input[type="radio"]::before {
        content: "";
        position: absolute;
        top: 0.125rem;
        left: 0.125rem;
        width: 0.375rem;
        height: 0.375rem;
        border-radius: 50%;
        background-color: ${COLORS.secondary};
    }
  `}
`;

export { Container };
